module.exports = __webpack_public_path__ + "img/Coursera_certificate.2d6ced1f.webp";